import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import text from 'styles/utility/text.module.scss'
import { CardGreyHeadline } from 'components/Card'
import { Spacer } from 'components/Utility'
import { ScheduleType } from 'types/schedule'
import { DaysOfWeek } from 'lib/daysOfWeek'
const daysOfWeek = new DaysOfWeek()

type Props = {
  schedules: ScheduleType[]
}

const ScheduleConfirmCard: FC<Props> = (props) => {
  const { schedules } = props
  return (
    <div className={styles.settings}>
      <div className={styles.settings__header}>
        <h4 className={styles.settings__header__title}>事前予約日の設定</h4>
      </div>
      <CardGreyHeadline headline={'受渡解禁時刻と販売上限数'} />
      {schedules.map((schedule) => {
        return (
          <div className={styles.settings__body} key={schedule.schedule_ref?.id}>
            <p className={`${text.font_small} ${text.font_bold}`}>
              {schedule.days_of_week
                .sort((a, b) => (daysOfWeek.getOrder(a) < daysOfWeek.getOrder(b) ? -1 : 1))
                .map((dayOfWeek) => daysOfWeek.getShortName(dayOfWeek))
                .join('・')}
            </p>
            <Spacer size={8} />
            {schedule.default_stocks.map((defaultStock) => (
              <p className={`${text.font_small}`} key={defaultStock.pickupable_time}>
                <span className={`${text.font_bold}`}>{defaultStock.pickupable_time}</span>
                に解禁される在庫数：
                <span className={`${text.font_bold}`}>{defaultStock.stock}個</span>
              </p>
            ))}
          </div>
        )
      })}
    </div>
  )
}

export default ScheduleConfirmCard
